import React, { useEffect, useState } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getItemDailyWeeklyMostView, getItemListSize, getProjectApi, getProjectCategory, getWriters, putProjectViewCount } from "../api";
import config from "../config";
import PlaceCard from "./PlaceCard";
import UserCard from "./UserCard";
import UserCardWrapper from "./UserCardWrapper";
import AuthorSlider from "./AuthorSlider";
import RandomArticleCard from "./RandomArticleCard";

const HomeSection = () => {
    const [data1, setData1] = useState([]);
    const [project, setProject] = useState({});
    const [categoryList, setCategoryList] = useState([]);
    const [writers, setWriters] = useState([]);
    const [dailyItems, setDailyItems] = useState([]);

    const getAPI = async()=>{


	const res =  getProjectCategory();			
	const res1 =  getProjectApi(config.project.id);		
	const res2 =  getItemDailyWeeklyMostView();
	const res3 =  getItemListSize(6);
	const res4 =  getWriters();


	Promise.all([res,res1,res2,res3,res4]).then((sonuclar)=>{
		////console.log("sonuclar ",sonuclar);
		setCategoryList(sonuclar[0].data);
        setData1(sonuclar[3].data);
        setProject(sonuclar[1].data);
        if(sonuclar[2]?.status && sonuclar[2]?.data?.daily) {
          setDailyItems(sonuclar[2].data.daily || []);
        }
        if(sonuclar[4]?.status) {
          setWriters(sonuclar[4].data || []);
        }

	})

    putProjectViewCount({})

    }
    useEffect(() => {
      getAPI(); 
    }, [])
    

    return (
        <div className="home-sections">
            <Container>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h2 className="title">ANSİKLOPEDİDE YENİ</h2>
                    <Link className="seeAll" to="/maddeler">Tümü</Link>
                </div>
                <UserCardWrapper>
                    <Row>
                        {data1.map((item, i) => (
                              <Col key={i} xs={6}>
                                <UserCard info={item} />
                              </Col>
                            ))}
                    </Row>
                </UserCardWrapper>
                         
                <div className="d-md-flex justify-content-center mt-4">
                    <h2 className="title _secondary">KATEGORİLER</h2>
                </div>
                <UserCardWrapper>
                    <Row className="d-sm-flex">
                        {categoryList.map((category, i) => (
                            //   <Col key={i} md={i < 2 ? 6 : 4}>
                                                              <Col key={i} md={4} sm={6} xs={6}>

                                <PlaceCard info={{...category,image: require(`../assets/category/${i+1}.png`)}} />
                              </Col>
                            ))}
                    </Row>
                    {/* <Categories className="d-md-none d-lg-none d-xl-none categoryCarousel" info={fakeData2}/> */}
                </UserCardWrapper>

                <div className="view_count">
            Görüntülenme Sayısı: {project.viewCount?.toLocaleString()}
          </div>

                <AuthorSlider writers={writers} />

                <RandomArticleCard dailyItems={dailyItems} />

            </Container>
        </div>
    )
}
export default HomeSection